"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LOOP = 8;
var FLOAT_MUL = 1 / 16777216;

function multiply_uint32(n, m) {
    n >>>= 0;
    m >>>= 0;
    var nlo = n & 0xffff;
    var nhi = n - nlo;
    return (nhi * m >>> 0) + nlo * m >>> 0;
}

var XSadd = (function () {
    function XSadd() {
        var seed = arguments.length <= 0 || arguments[0] === undefined ? Date.now() : arguments[0];

        _classCallCheck(this, XSadd);

        this.state = new Uint32Array(4);
        this.init(seed);
    }

    _createClass(XSadd, [{
        key: "init",
        value: function init(seed) {
            this.state[0] = seed;
            this.state[1] = 0;
            this.state[2] = 0;
            this.state[3] = 0;
            for (var i = 1; i < LOOP; i++) {
                this.state[i & 3] ^= i + multiply_uint32(1812433253, this.state[i - 1 & 3] ^ this.state[i - 1 & 3] >>> 30 >>> 0) >>> 0;
            }
            period_certification(this);
            for (var i = 0; i < LOOP; i++) {
                next_state(this);
            }
        }

        /**
         * Returns a 32-bit integer r (0 <= r < 2^32)
         */
    }, {
        key: "getUint32",
        value: function getUint32() {
            next_state(this);
            return this.state[3] + this.state[2] >>> 0;
        }

        /**
         * Returns a floating point number r (0.0 <= r < 1.0)
         */
    }, {
        key: "getFloat",
        value: function getFloat() {
            return (this.getUint32() >>> 8) * FLOAT_MUL;
        }
    }, {
        key: "random",
        get: function get() {
            if (!this._random) {
                this._random = this.getFloat.bind(this);
            }
            return this._random;
        }
    }]);

    return XSadd;
})();

exports["default"] = XSadd;

function period_certification(xsadd) {
    if (xsadd.state[0] === 0 && xsadd.state[1] === 0 && xsadd.state[2] === 0 && xsadd.state[3] === 0) {
        xsadd.state[0] = 88; // X
        xsadd.state[1] = 83; // S
        xsadd.state[2] = 65; // A
        xsadd.state[3] = 68; // D
    }
}

var sh1 = 15;
var sh2 = 18;
var sh3 = 11;
function next_state(xsadd) {
    var t = xsadd.state[0];
    t ^= t << sh1;
    t ^= t >>> sh2;
    t ^= xsadd.state[3] << sh3;
    xsadd.state[0] = xsadd.state[1];
    xsadd.state[1] = xsadd.state[2];
    xsadd.state[2] = xsadd.state[3];
    xsadd.state[3] = t;
}
module.exports = exports["default"];



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-xsadd/xsadd-es5.js
 ** module id = 96
 ** module chunks = 0
 **/